import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {CustomersComponent} from './customers.component';
import {CustomersSummaryComponent} from './customers-summary/customers-summary.component';
import {CustomersDialogComponent} from './customers-dialog/customers-dialog.component';
import {FormsModule} from '@angular/forms';
import {FlexModule} from '@angular/flex-layout';
import {PipsModule} from '../../pipes/pips.module';
import {DialogModule} from '../../components/dialog/dialog.module';
import {ColumnsFilterModule} from '../../components/columns-filter/columns-filter.module';
import {MapModule} from '../map/map.module';
import {SearchModule} from '../../components/search/search.module';
import {MaterialModule} from '../../material.module';
import {ActionBarModule} from '../../components/action-bar/action-bar.module';
import {CustomersSearchComponent} from './customers-search/customers-search.component';
import {LayoutModule} from '../../components/layout/layout.module';
import {ArmTableModule} from '../../components/arm-table/arm-table.module';
import {InfraModule} from 'ac-infra';
import {ArmMatErrorModule} from "../../components/arm-mat-error/arm-mat-error.module";

@NgModule({
  declarations: [
    CustomersComponent,
    CustomersSummaryComponent,
    CustomersDialogComponent,
    CustomersSearchComponent
  ],
    imports: [
        CommonModule,
        PipsModule,
        FormsModule,
        FlexModule,
        DialogModule,
        ColumnsFilterModule,
        MapModule,
        LayoutModule,
        SearchModule,
        MaterialModule,
        ActionBarModule,
        LayoutModule,
        ArmTableModule,
        InfraModule,
        ArmMatErrorModule
    ]
})
export class CustomersModule {

}
